{
  "admin.activity.type.kbEdit": "KB edit",
  "admin.activity.type.meetCall": "Meet call",
  "admin.activity.type.noteEdit": "Note edit",
  "admin.activity.type.standup": "Standup",
  "admin.activity.type.ticketUpdate": "Ticket update",
  "admin.activityScoring.allSaved": "All changes saved.",
  "admin.activityScoring.col.activity": "Activity",
  "admin.activityScoring.col.description": "Description",
  "admin.activityScoring.col.enabled": "Enabled",
  "admin.activityScoring.col.score": "Score (pts)",
  "admin.activityScoring.dirty": "Unsaved changes",
  "admin.activityScoring.error.noneSaved": "Changes were not saved.",
  "admin.activityScoring.error.someSaved": "{rejected} of {total} changes were not saved.",
  "admin.activityScoring.reason.network": "network or server error",
  "admin.activityScoring.reason.rejected": "save was rejected",
  "admin.activityScoring.intro": "Each event below is scored when the underlying action happens (standup saved, task moved, note edited, KB doc updated, call analyzed). Scores are snapshot-per-event — editing a score changes future events only, never rewrites history. Disabling an activity stops emitting new events of that type.",
  "admin.activityScoring.page.title": "Activity scoring / Admin",
  "admin.activityScoring.reset": "Reset",
  "admin.activityScoring.save": "Save changes",
  "admin.activityScoring.saved": "Saved.",
  "admin.activityScoring.saving": "Saving…",
  "admin.activityScoring.title": "Activity Scoring",
  "admin.activityScoring.toast.noneSaved": "Changes were not saved",
  "admin.activityScoring.toast.someSaved": "{rejected} of {total} changes were not saved",
  "admin.analytics.disabled": "Disabled",
  "admin.analytics.enabled": "Enabled",
  "admin.analytics.error.loadOrg": "Could not read the organization's analytics setting.",
  "admin.analytics.error.loadProjects": "Failed to load projects",
  "admin.analytics.error.updateOrg": "Failed to update org analytics: {error}",
  "admin.analytics.error.updateProject": "Failed to update {name}: {error}",
  "admin.analytics.how.defaultOn": "Analytics defaults to enabled (opt-in model).",
  "admin.analytics.how.injector": "The tracker is injected by the mermaid CDN worker via HTMLRewriter.",
  "admin.analytics.how.orgOff": "Disabling org-level analytics prevents injection across ALL projects.",
  "admin.analytics.how.perProject": "Per-project toggles only apply when org-level analytics is on.",
  "admin.analytics.how.timing": "Changes take effect on the next preview page load.",
  "admin.analytics.how.title": "How it works",
  "admin.analytics.loadingProjects": "Loading projects",
  "admin.analytics.noOrg": "No active org in JWT claims",
  "admin.analytics.org.desc": "When disabled, the analytics tracking snippet is NOT injected on any project preview for this organization, regardless of per-project settings.",
  "admin.analytics.org.label": "Org-level analytics",
  "admin.analytics.org.title": "Organization-Wide Analytics",
  "admin.analytics.orgId": "Org ID: {id}",
  "admin.analytics.page.title": "Analytics / Admin",
  "admin.analytics.projectOff": "Analytics off",
  "admin.analytics.projectOn": "Analytics on",
  "admin.analytics.projectToggleAria": "Analytics for {name}",
  "admin.analytics.projects.desc": "Toggle analytics tracking per project. Takes effect on next preview load. Org-level opt-out overrides all per-project settings.",
  "admin.analytics.projects.empty": "No projects found for this organization.",
  "admin.analytics.projects.title": "Per-Project Analytics",
  "admin.analytics.refresh": "Refresh",
  "admin.analytics.title": "Analytics Opt-Out",
  "admin.app.analytics": "Analytics",
  "admin.app.announcements": "Announcements",
  "admin.app.calendar": "Calendar",
  "admin.app.chat": "Chat",
  "admin.app.company": "Company",
  "admin.app.data": "Data",
  "admin.app.documents": "Documents",
  "admin.app.files": "Files",
  "admin.app.meet": "Meet",
  "admin.app.reminders": "Reminders",
  "admin.app.resolutions": "Resolutions",
  "admin.app.tickets": "Tasks",
  "admin.branding.colors.desc": "Hex values only. The server refuses anything else, because these colours are written into a public page.",
  "admin.branding.colors.title": "Colours",
  "admin.branding.error.adminOnly": "Your role in this organization does not allow a branding change.",
  "admin.branding.error.fileRead": "Could not read that file.",
  "admin.branding.error.generic": "Could not save the branding.",
  "admin.branding.error.invalidColor": "{field} must be a hex colour, for example #3366ff.",
  "admin.branding.error.noOrg": "No active organization.",
  "admin.branding.error.notReady": "The connection to the server is not ready yet. Try again in a moment.",
  "admin.branding.error.saveFailed": "Could not save the branding",
  "admin.branding.field.accent": "Accent",
  "admin.branding.field.background": "Background — dark",
  "admin.branding.field.backgroundLight": "Background — light",
  "admin.branding.field.lang": "Sign-in language",
  "admin.branding.field.loaderLogoSvg": "Loader mark",
  "admin.branding.field.logoSvg": "Logo",
  "admin.branding.field.name": "Brand name",
  "admin.branding.field.tagline": "Tagline",
  "admin.branding.field.theme": "Theme",
  "admin.branding.hint.background": "The ground the branded surfaces use in the dark scheme.",
  "admin.branding.hint.backgroundLight": "The ground for the light scheme. Empty means a neutral ground.",
  "admin.branding.hint.marks": "The logo paints the branded sign-in page. The loader mark paints the boot screen; without it the logo is used.",
  "admin.branding.identity.desc": "The name and the line shown on your branded sign-in page.",
  "admin.branding.identity.title": "Identity",
  "admin.branding.marks.desc": "Paste the SVG markup, or load an .svg file into the box. The server removes scripts and event handlers before it stores a mark.",
  "admin.branding.marks.title": "Marks",
  "admin.branding.option.unset": "Not set",
  "admin.branding.presentation.desc": "How the branded sign-in page and the boot loader open. Neither value changes the app after sign-in.",
  "admin.branding.presentation.title": "Presentation",
  "admin.branding.save": "Save branding",
  "admin.branding.savedBody": "The branded sign-in page and the loader use the new values on the next load.",
  "admin.branding.savedTitle": "Branding saved",
  "admin.branding.saving": "Saving…",
  "admin.branding.theme.auto": "Follow the device",
  "admin.branding.theme.dark": "Dark",
  "admin.branding.theme.light": "Light",
  "admin.branding.title": "Branding",
  "admin.branding.unsaved": "You have unsaved changes.",
  "admin.branding.upload.loaderLogoSvg": "Load an .svg file for the loader mark",
  "admin.branding.upload.logoSvg": "Load an .svg file for the logo",
  "admin.danger.btn.done": "Done",
  "admin.danger.btn.failed": "Failed",
  "admin.danger.btn.working": "Working…",
  "admin.danger.deactivate.button": "Deactivate",
  "admin.danger.deactivate.confirmMessage": "Everyone in this workspace without a core role gets the status “left”. Admins, managers and members keep theirs. This cannot be undone in one step.",
  "admin.danger.deactivate.hint": "Set status to \"left\" for everyone without a core role",
  "admin.danger.deactivate.label": "Deactivate all non-core members",
  "admin.danger.deactivate.noRoster": "The member list is not loaded yet. Try again in a moment.",
  "admin.danger.deactivate.none": "No member to deactivate: everyone has a core role or has already left.",
  "admin.danger.deactivate.notAllowed": "Only a platform superuser can deactivate members.",
  "admin.danger.deactivate.titleMany": "Deactivate {count} members?",
  "admin.danger.deactivate.titleOne": "Deactivate 1 member?",
  "admin.danger.destructive": "Destructive Actions",
  "admin.danger.domain.notAllowed": "This action is not available on this domain.",
  "admin.danger.export.button": "Export JSON",
  "admin.danger.export.confirmMessage": "The JSON file holds all users, their roles and equity data. Anyone who has the file can read it.",
  "admin.danger.export.confirmTitle": "Export all user data?",
  "admin.danger.export.download": "Download JSON",
  "admin.danger.export.hint": "Download all users, roles, and equity data as JSON",
  "admin.danger.export.label": "Export all user data",
  "admin.danger.hint": "These actions are irreversible.",
  "admin.danger.page.title": "Danger zone / Admin",
  "admin.danger.purgeChat.button": "Purge messages",
  "admin.danger.purgeChat.confirmMessage": "Every message in every channel is deleted for everyone, with its reactions and mentions. The channels and their members stay. This cannot be undone.",
  "admin.danger.purgeChat.confirmTitle": "Delete all chat messages in “{workspace}”?",
  "admin.danger.purgeChat.confirmTitleAll": "Delete all chat messages in this workspace?",
  "admin.danger.purgeChat.hint": "Delete every message in THIS workspace across all channels — channel structure is preserved",
  "admin.danger.purgeChat.label": "Purge all chat messages",
  "admin.danger.purgeChat.notAllowed": "Only a platform admin can purge chat messages.",
  "admin.danger.title": "Danger Zone",
  "admin.data.nav": "Data export",
  "admin.data.page.title": "Data export / Admin",
  "admin.data.title": "Data export",
  "admin.data.card.title": "Export all workspace data",
  "admin.data.card.desc": "One ZIP file. It holds the records of each app as JSON and CSV, the members and their roles, the settings, the payment records and a list of files with download links.",
  "admin.data.card.scope": "You get the shared data and your own private records. Card numbers are never in the file.",
  "admin.data.card.access": "Only a workspace owner or admin can export.",
  "admin.data.start": "Start export",
  "admin.data.startTitle": "Export all workspace data?",
  "admin.data.startMessage": "The ZIP file holds the records of every app, the members and their roles, the settings and the payment records. Anyone who has the file can read them.",
  "admin.data.starting": "Starting…",
  "admin.data.opening": "Opening…",
  "admin.data.deleteTitle": "Delete this export?",
  "admin.data.deleteMessage": "Requested: {date}. The export and its file are deleted for good. To get the data again, start a new export.",
  "admin.data.list.title": "Your exports",
  "admin.data.list.empty": "No exports yet.",
  "admin.data.list.loading": "Loading exports",
  "admin.data.status.queued": "Queued",
  "admin.data.status.running": "Running",
  "admin.data.status.ready": "Ready",
  "admin.data.status.expired": "Expired",
  "admin.data.status.failed": "Failed",
  "admin.data.row.requested": "Requested: {date}",
  "admin.data.row.until": "Available until: {date}",
  "admin.data.row.size": "{size} · {rows} records",
  "admin.data.row.progress": "Step {done} of {total}",
  "admin.data.row.queued": "Waiting to start.",
  "admin.data.row.expired": "The file is no longer available.",
  "admin.data.fail.roleRevoked": "Your role changed, so the export stopped.",
  "admin.data.fail.tooLarge": "The data is too large for one file. Contact support.",
  "admin.data.fail.workerLost": "The export stopped. Start a new one.",
  "admin.data.fail.other": "The export failed. Start a new one.",
  "admin.data.error.inProgress": "An export is already running. Wait until it ends.",
  "admin.data.error.rateLimited": "Limit reached: {limit} exports in 24 hours. Try again after: {time}",
  "admin.data.error.notReady": "Not ready yet. Try again.",
  "admin.data.error.expired": "This export expired. Start a new one.",
  "admin.data.error.notFound": "This export is not found.",
  "admin.data.error.unavailable": "The export service is not available now. Try again later.",
  "admin.data.error.generic": "Something went wrong. Try again.",
  "admin.data.error.load": "Could not load your exports.",
  "admin.dashboardDefaults.card.desc": "Panels new members see by default on their home dashboard. Everyone can still personalize their own — these are only the starting defaults. The greeting card is always shown.",
  "admin.dashboardDefaults.card.title": "Default home panels",
  "admin.dashboardDefaults.hidden": "Hidden by default",
  "admin.dashboardDefaults.needsAdmin": "Saving requires a workspace-admin role.",
  "admin.dashboardDefaults.noWorkspace": "No active workspace.",
  "admin.dashboardDefaults.page.title": "Dashboard Defaults / Admin",
  "admin.dashboardDefaults.saveFailed": "Couldn't save dashboard default",
  "admin.dashboardDefaults.sdkNotReady": "SDK not ready.",
  "admin.dashboardDefaults.shown": "Shown by default",
  "admin.dashboardDefaults.title": "Dashboard Defaults",
  "admin.domains.addCta": "Add domain",
  "admin.domains.added": "Domain added",
  "admin.domains.addedBody": "{domain} is attached. It starts serving once DNS and TLS verify.",
  "admin.domains.adding": "Adding…",
  "admin.domains.card.desc": "Serve this workspace on your own hostname. Point a CNAME at the Symbols edge first — the domain stays inactive until the DNS and the certificate verify.",
  "admin.domains.card.title": "Add a domain",
  "admin.domains.error.add": "Could not add the domain.",
  "admin.domains.error.load": "Could not load the domains.",
  "admin.domains.error.noOrg": "No active organization or workspace.",
  "admin.domains.error.notReady": "The connection is not ready yet. Try again.",
  "admin.domains.field.hostname": "Hostname",
  "admin.domains.list.empty": "No domains attached yet.",
  "admin.domains.list.title": "Attached domains",
  "admin.domains.loading": "Loading domains",
  "admin.domains.page.title": "White-label Domains / Admin",
  "admin.domains.pending": "Pending DNS + certificate verification",
  "admin.domains.placeholder.hostname": "e.g. app.example.com",
  "admin.domains.title": "White-label Domains",
  "admin.domains.upsell.currentPlan": "This organization is currently on the {tier} plan.",
  "admin.domains.upsell.seePlans": "See plans",
  "admin.domains.upsell.title": "White-label domains need a higher plan",
  "admin.domains.upsell.titleNamed": "White-label domains are a {tier} feature",
  "admin.domains.verified": "Verified — serving",
  "admin.flags.alwaysOn": "Always on",
  "admin.flags.coreTitle": "Core feature — always on",
  "admin.flags.disclosureAria": "Show {flag} sub-features",
  "admin.flags.intro": "Everything the workspace ships, in one place. Switch features on or off for this workspace — Basics are the foundation and stay always on. Click a feature to open its sub-features. Changes save to the workspace and apply to everyone in it.",
  "admin.flags.page.title": "Feature flags / Admin",
  "admin.flags.subCount": "{count} sub-features",
  "admin.flags.subCountOne": "1 sub-feature",
  "admin.flags.title": "Feature flags",
  "admin.flags.toggleAria": "Toggle {flag}",
  "admin.flags.turnOff": "Turn off",
  "admin.flags.turnOn": "Turn on",
  "admin.gh.addBoard": "+ Add a Projects board",
  "admin.gh.auth.hint": "No PAT required. Server auths every call as the org-installed App; tokens auto-rotate hourly. Install/uninstall via github.com/organizations/<org>/settings/installations.",
  "admin.gh.auth.link": "Install or manage the GitHub App →",
  "admin.gh.auth.title": "Auth: the org-installed GitHub App",
  "admin.gh.back": "← Integrations",
  "admin.gh.cancel": "Cancel",
  "admin.gh.connect": "Connect",
  "admin.gh.connectFailed": "Connect failed",
  "admin.gh.connected": "Connected",
  "admin.gh.disconnected": "Disconnected",
  "admin.gh.emptyHint": "Add a GitHub Projects v2 board to keep its tasks in sync with this workspace.",
  "admin.gh.emptyTitle": "No boards connected yet",
  "admin.gh.field.displayName": "Display name",
  "admin.gh.field.owner": "Repo owner / org (required)",
  "admin.gh.field.projectId": "Projects v2 ID (required)",
  "admin.gh.field.slug": "Slug",
  "admin.gh.form.title": "Add a GitHub Projects v2 board",
  "admin.gh.intro": "Tasks in governance stay in sync with GitHub Projects v2. Every board below is a separate slot — add one per team, per product, or per org you want to mirror.",
  "admin.gh.meta": "Slug: {slug} · Owner: {owner} · Project: {project}",
  "admin.gh.missingFields": "Missing required fields",
  "admin.gh.missingFieldsBody": "Owner and project ID are required. (Auth is the org-installed GitHub App — no PAT.)",
  "admin.gh.noWorkspace": "No active workspace",
  "admin.gh.page.title": "GitHub / Integrations",
  "admin.gh.placeholder.displayName": "Product board",
  "admin.gh.placeholder.owner": "e.g. acme",
  "admin.gh.placeholder.slug": "e.g. acme-main",
  "admin.gh.pullNow": "Pull now",
  "admin.gh.remove": "Remove",
  "admin.gh.removeTitle": "Remove “{board}”?",
  "admin.gh.removeMessage": "The connection is deleted and new sync stops. Tickets already synced stay in governance.",
  "admin.gh.removeFailed": "Remove failed",
  "admin.gh.saving": "Saving…",
  "admin.gh.scopeRequired": "Scope target required",
  "admin.gh.scopeRequiredBody": "Select a {scope} or switch scope to Org.",
  "admin.gh.serverError": "Server error",
  "admin.gh.syncFailed": "Sync failed",
  "admin.gh.syncStarted": "Sync started",
  "admin.gh.syncing": "Syncing…",
  "admin.gh.title": "GitHub",
  "admin.google.back": "← Integrations",
  "admin.google.configOnly": "Config only (no service account key)",
  "admin.google.configuredDisabled": "Configured · disabled",
  "admin.google.configuredEnabled": "Configured · enabled",
  "admin.google.domainRequired": "Domain required",
  "admin.google.field.adminEmail": "Admin email (DWD subject)",
  "admin.google.field.domain": "Workspace domain",
  "admin.google.intro": "Domain-wide delegation authorizes governance to sync calendars on behalf of every user in the workspace. Rotate the service account JSON to revoke access.",
  "admin.google.noWorkspace": "No active workspace",
  "admin.google.notConfigured": "Not configured",
  "admin.google.page.title": "Google Workspace / Integrations",
  "admin.google.placeholder.adminEmail": "e.g. admin@example.com",
  "admin.google.placeholder.domain": "e.g. example.com",
  "admin.google.pullCalendar": "Pull calendar",
  "admin.google.remove": "Remove integration",
  "admin.google.removeTitle": "Remove the Google Workspace integration?",
  "admin.google.removeMessage": "Its stored credentials are deleted and calendar sync stops.",
  "admin.google.removeFailed": "Remove failed",
  "admin.google.removed": "Removed",
  "admin.google.save": "Save",
  "admin.google.saveFailed": "Save failed",
  "admin.google.saved": "Saved",
  "admin.google.saving": "Saving…",
  "admin.google.secret.hint": "Must have domain-wide delegation and the calendar read/write scopes authorized in Google Admin.",
  "admin.google.secret.label": "Service account JSON (paste new to rotate — leave empty to keep)",
  "admin.google.serverError": "Server error",
  "admin.google.syncFailed": "Sync failed",
  "admin.google.syncStarted": "Sync started",
  "admin.google.syncing": "Syncing…",
  "admin.google.title": "Google Workspace",
  "admin.integrations.addAnother": "+ Add another",
  "admin.integrations.back": "← Integrations",
  "admin.integrations.browse": "Browse integrations →",
  "admin.integrations.cap.imageGenerate": "Image generation",
  "admin.integrations.cap.textEmbed": "Text embeddings",
  "admin.integrations.cap.textGenerate": "Text generation",
  "admin.integrations.card.configured": "Configured",
  "admin.integrations.card.connected": "{count} connected",
  "admin.integrations.category.ai": "AI providers",
  "admin.integrations.category.analytics": "Analytics",
  "admin.integrations.category.automation": "Automation",
  "admin.integrations.category.custom": "Custom",
  "admin.integrations.category.data": "Data sources",
  "admin.integrations.category.dev": "Developer tools",
  "admin.integrations.category.messaging": "Real-time & messaging",
  "admin.integrations.category.other": "Other",
  "admin.integrations.category.workspace": "Workspace",
  "admin.integrations.configure": "+ Configure",
  "admin.integrations.empty.body": "Connect data sources, AI providers, dev tools and messaging from the marketplace — they show up here once configured.",
  "admin.integrations.empty.cta": "Open marketplace →",
  "admin.integrations.empty.title": "No integrations configured yet",
  "admin.integrations.generic.emptyHint": "Connect it with the button above. Credentials are stored in the server-side vault.",
  "admin.integrations.generic.emptyTitle": "Not connected yet",
  "admin.integrations.generic.unknownHint": "This integration is not in the catalogue. Go back to Integrations or browse the marketplace.",
  "admin.integrations.generic.unknownTitle": "Unknown integration",
  "admin.integrations.genericPage.title": "{name} / Integrations",
  "admin.integrations.genericTitle": "Integration",
  "admin.integrations.hint": "Active integrations for {org}. Credentials live in the server-side vault; every surface reads from the same registry.",
  "admin.integrations.loading": "Loading integrations",
  "admin.integrations.page.title": "Integrations / Admin",
  "admin.integrations.thisOrg": "this org",
  "admin.integrations.title": "Integrations",
  "admin.logs.author.stats": "{count} events · {score} pts",
  "admin.logs.author.statsOne": "1 event · {score} pts",
  "admin.logs.clearDate": "× Clear date filter",
  "admin.logs.day.eventCount": "{count} events",
  "admin.logs.day.eventCountOne": "1 event",
  "admin.logs.empty": "No activity events for this filter.",
  "admin.logs.error.load": "The activity log could not be read.",
  "admin.logs.filterByDate": "Filter by date",
  "admin.logs.intro.peopleCount": "{count} people",
  "admin.logs.intro.personCount": "{count} person",
  "admin.logs.intro.text": "{count} events {scope} from {people}.",
  "admin.logs.page.title": "Logs / Admin",
  "admin.logs.scope.allDates": "across all dates",
  "admin.logs.scope.onDate": "on {date}",
  "admin.logs.title": "Activity Logs",
  "admin.mail.accounts.desc": "Health only — the workspace never shows an admin the content of a member's mailbox.",
  "admin.mail.accounts.empty": "No connected accounts yet.",
  "admin.mail.accounts.title": "Connected accounts",
  "admin.mail.audit.empty": "No mail admin actions yet.",
  "admin.mail.audit.openLogs": "Open activity logs",
  "admin.mail.audit.title": "Audit",
  "admin.mail.loading": "Loading…",
  "admin.mail.page.title": "Mail / Admin",
  "admin.mail.policy.aiDraft": "Assistant may draft replies",
  "admin.mail.policy.aiDraftDesc": "Drafts only — sending stays a member action.",
  "admin.mail.policy.aiRead": "Assistant may read mail",
  "admin.mail.policy.aiReadDesc": "Summaries and triage over messages the member can already read.",
  "admin.mail.policy.allowPersonal": "Who may connect personal accounts",
  "admin.mail.policy.allowPersonalDesc": "Personal Gmail or Outlook mailboxes connected by the member.",
  "admin.mail.policy.attachments": "Save attachments to Files",
  "admin.mail.policy.attachmentsDesc": "Members may copy attachments into workspace Files.",
  "admin.mail.policy.autoProvision": "Auto-provision tenant mailboxes",
  "admin.mail.policy.autoProvisionDesc": "Create a mailbox for every new member the directory matches.",
  "admin.mail.policy.bodyCache": "Body cache",
  "admin.mail.policy.bodyCacheDesc": "How long fetched message bodies stay stored.",
  "admin.mail.policy.cache30": "30 days",
  "admin.mail.policy.cache7": "7 days",
  "admin.mail.policy.cache90": "90 days",
  "admin.mail.policy.desc": "Workspace mail rules. Each change saves on its own.",
  "admin.mail.policy.deskAssignee": "Default assignee",
  "admin.mail.policy.deskAssigneeDesc": "New service-desk tickets assign to this member.",
  "admin.mail.policy.deskAutoTicket": "Auto-create a ticket per new thread",
  "admin.mail.policy.deskAutoTicketDesc": "One ticket per new shared-inbox thread.",
  "admin.mail.policy.deskConversations": "Shared-inbox threads create Conversations",
  "admin.mail.policy.deskConversationsDesc": "Every shared-inbox thread lands in the service desk.",
  "admin.mail.policy.deskTeam": "Default team",
  "admin.mail.policy.deskTeamDesc": "New service-desk tickets route to this team.",
  "admin.mail.policy.disable": "Turn off",
  "admin.mail.policy.disableMessage": "Members stop seeing Mail, and no one can connect a mailbox until you turn it back on. Nothing is deleted.",
  "admin.mail.policy.disableTitle": "Turn off Mail for this workspace?",
  "admin.mail.policy.domains": "Allowed sign-in domains",
  "admin.mail.policy.domainsDesc": "Personal addresses must be on one of these domains. Empty means no restriction.",
  "admin.mail.policy.domainsPlaceholder": "acme.com — press Enter",
  "admin.mail.policy.enabled": "Mail enabled for this workspace",
  "admin.mail.policy.enabledDesc": "The admin's copy of the product switch — members see Mail only while this is on.",
  "admin.mail.policy.imagesAsk": "Ask",
  "admin.mail.policy.imagesBlock": "Block",
  "admin.mail.policy.none": "None",
  "admin.mail.policy.personalEveryone": "Everyone",
  "admin.mail.policy.personalNobody": "Nobody",
  "admin.mail.policy.personalOrg": "Only org domains",
  "admin.mail.policy.remoteImages": "Remote images default",
  "admin.mail.policy.remoteImagesDesc": "How messages load remote images before the member decides.",
  "admin.mail.policy.title": "Policy",
  "admin.mail.policy.window": "Mirror window",
  "admin.mail.policy.window30": "30 days",
  "admin.mail.policy.window365": "365 days",
  "admin.mail.policy.window90": "90 days",
  "admin.mail.policy.windowAll": "All mail",
  "admin.mail.policy.windowDesc": "How far back message metadata syncs.",
  "admin.mail.providers.desc": "Connect Google Workspace or Microsoft 365 so member mailboxes are provisioned without a per-user sign-in. The steps below carry your organization's own values.",
  "admin.mail.providers.title": "Organization mail providers",
  "admin.mail.shared.add": "Add shared inbox",
  "admin.mail.shared.desc": "support@, sales@ — one mailbox, granted to people and teams.",
  "admin.mail.shared.empty": "No shared inboxes yet.",
  "admin.mail.shared.title": "Shared inboxes",
  "admin.mail.title": "Mail",
  "admin.mcp.add": "+ New MCP connector",
  "admin.mcp.back": "← Integrations",
  "admin.mcp.capabilities": "Capabilities",
  "admin.mcp.capsRefreshed": "Capabilities refreshed",
  "admin.mcp.connectSymbols": "Connect Symbols MCP",
  "admin.mcp.deleteFailed": "Delete failed",
  "admin.mcp.deleteMessage": "The connector is deleted, and the AI can no longer use its tools.",
  "admin.mcp.deleteTitle": "Disconnect “{name}”?",
  "admin.mcp.disable": "Disable",
  "admin.mcp.disabled": "Disabled",
  "admin.mcp.disconnect": "Disconnect",
  "admin.mcp.disconnected": "Disconnected",
  "admin.mcp.discoveryFailed": "Discovery failed",
  "admin.mcp.empty.hint": "Connect the Symbols MCP server or any other MCP-compatible server to give canvas AI agents access to tools and resources.",
  "admin.mcp.empty.title": "No MCP connectors yet",
  "admin.mcp.enable": "Enable",
  "admin.mcp.enabled": "Enabled",
  "admin.mcp.live": "Live",
  "admin.mcp.loadError": "Couldn't load connectors: {error}",
  "admin.mcp.page.title": "MCP Connectors / Integrations",
  "admin.mcp.rediscover": "Re-discover",
  "admin.mcp.rediscoverTitle": "Re-run tools/list + resources/list",
  "admin.mcp.row.auth": "Auth",
  "admin.mcp.row.transport": "Transport",
  "admin.mcp.row.url": "URL",
  "admin.mcp.subtitle": "Remote MCP servers available to canvas AI agents as tool providers.",
  "admin.mcp.title": "MCP Connectors",
  "admin.mcp.updateFailed": "Update failed",
  "admin.module.apps.add": "+ Add app",
  "admin.module.apps.desc": "App-launcher entries — title, caption, icon, icon background token, and route.",
  "admin.module.apps.remove": "Remove app",
  "admin.module.apps.save": "Save apps",
  "admin.module.apps.title": "Apps",
  "admin.module.appsField.caption": "Caption",
  "admin.module.appsField.icon": "Icon",
  "admin.module.appsField.iconBg": "Icon bg (token)",
  "admin.module.appsField.route": "Route",
  "admin.module.appsField.title": "Title",
  "admin.module.assign.desc": "Point this workspace at a published module project. Owner defaults to your organization slug (Tier-1 self-serve). The server validates the reference and clamps the tier before it takes effect.",
  "admin.module.assign.confirmMessage": "Everyone in this workspace gets this module. It replaces the module that is assigned now.",
  "admin.module.assign.confirmTitle": "Assign “{module}” to this workspace?",
  "admin.module.assign.save": "Save module",
  "admin.module.assign.saving": "Saving…",
  "admin.module.assign.title": "Assign module",
  "admin.module.danger.desc": "Detach the module from this workspace and reset navbar, apps, and home panels to defaults.",
  "admin.module.danger.title": "Danger zone",
  "admin.module.danger.uninstall": "Uninstall module",
  "admin.module.danger.uninstalling": "Uninstalling…",
  "admin.module.design.apply": "Apply design system",
  "admin.module.design.applying": "Applying…",
  "admin.module.design.canvasBg": "canvas background",
  "admin.module.design.desc": "A guarded skin — { \"canvasBg\": …, \"vars\": { … } }. Validate to preview below, then Apply. Invalid JSON is never saved.",
  "admin.module.design.placeholder": "e.g. { \"canvasBg\": \"…\", \"vars\": { } }",
  "admin.module.design.preview": "Preview (not yet applied)",
  "admin.module.design.title": "Design system",
  "admin.module.design.validate": "Validate",
  "admin.module.field.channel": "Channel",
  "admin.module.field.channelPlaceholder": "e.g. production",
  "admin.module.field.key": "Key",
  "admin.module.field.keyPlaceholder": "e.g. workspace-module",
  "admin.module.field.owner": "Owner (org slug)",
  "admin.module.field.ownerPlaceholder": "e.g. your-org",
  "admin.module.field.tier": "Tier (requested)",
  "admin.module.field.version": "Version (pin)",
  "admin.module.integrations.desc": "The OrgIntegration kinds + capability calls this app may reach through the moduleData bridge. Operator-granted only — no app can request this by publishing a manifest.",
  "admin.module.integrations.title": "Integrations grant",
  "admin.module.kv.capabilities": "Capabilities",
  "admin.module.kv.channel": "Channel",
  "admin.module.kv.kinds": "Kinds",
  "admin.module.kv.ownerKey": "Owner / key",
  "admin.module.kv.tier": "Tier",
  "admin.module.kv.version": "Version",
  "admin.module.level.acl": "Rows shared with them",
  "admin.module.level.member": "Everyone in the workspace",
  "admin.module.level.own": "Own rows only",
  "admin.module.level.scoped": "Rows by {field}",
  "admin.module.migrate.desc": "This app is still installed in the older single-slot format. Moving it into the app list lets you manage it the same way as every app installed since — remove just this one, pick it in the app picker above — without changing anything it does.",
  "admin.module.migrate.move": "Move to app list",
  "admin.module.migrate.moving": "Moving…",
  "admin.module.migrate.title": "Move to the app list",
  "admin.module.nav.dragToReorder": "Drag to reorder",
  "admin.module.nav.labelPlaceholder": "Label",
  "admin.module.nav.moveDown": "Move down",
  "admin.module.nav.moveUp": "Move up",
  "admin.module.nav.pathAria": "Path",
  "admin.module.nav.pathPlaceholder": "e.g. /crm",
  "admin.module.navbar.addTab": "+ Add tab",
  "admin.module.navbar.desc": "Top navigation tabs for this workspace — each is a label + route.",
  "admin.module.navbar.reset": "Reset to defaults",
  "admin.module.navbar.resetConfirmMessage": "The navbar and the home page widgets go back to their defaults for everyone in this workspace, and your own home layout is cleared. Custom tabs and widget choices are lost.",
  "admin.module.navbar.resetConfirmTitle": "Reset the navbar and the home page to defaults?",
  "admin.module.navbar.resetTitle": "Reset navbar AND the / page widgets to defaults",
  "admin.module.navbar.save": "Save navbar",
  "admin.module.navbar.title": "Navbar",
  "admin.module.notify.appGone": "App no longer installed",
  "admin.module.notify.appsChanged": "Installed apps changed while you were editing",
  "admin.module.notify.appsChangedBody": "Someone installed or uninstalled an app in this workspace. The list has been reloaded — nothing was written. Re-apply your grant change on top of it.",
  "admin.module.notify.assignFailed": "Assign failed",
  "admin.module.notify.assignFailedBody": "The server rejected the module reference.",
  "admin.module.notify.assigned": "Module set to {module}",
  "admin.module.notify.cantRevokeAll": "Can't revoke every operation",
  "admin.module.notify.cantRevokeAllBody": "An empty grant means \"all operations\" to the module bridge — revoke the collection instead.",
  "admin.module.notify.checkFirst": "Check for updates first",
  "admin.module.notify.dsValid": "Design system JSON is valid",
  "admin.module.notify.dsValidBody": "Preview below, then Apply.",
  "admin.module.notify.grantSynced": "Grant synced",
  "admin.module.notify.levelStale": "The app's access changed again",
  "admin.module.notify.levelStaleBody": "Nothing was written. Check for updates again, then approve what the app asks for now.",
  "admin.module.notify.migrated": "Moved to the app list",
  "admin.module.notify.migratedBody": "{module} now manages the same as any other installed app.",
  "admin.module.notify.migrationFailed": "Migration failed",
  "admin.module.notify.missingRef": "Missing module reference",
  "admin.module.notify.missingRefBody": "Owner and key are required.",
  "admin.module.notify.noAppSelected": "No installed app selected",
  "admin.module.notify.noAppToCheck": "No installed app to check",
  "admin.module.notify.noModule": "No module assigned",
  "admin.module.notify.nothingSelected": "Nothing selected",
  "admin.module.notify.nothingSelectedBody": "Check an added or stale collection to sync it.",
  "admin.module.notify.nothingToMigrate": "Nothing to migrate",
  "admin.module.notify.nothingToMigrateBody": "No legacy single-slot app install found on this workspace.",
  "admin.module.notify.pinned": "Pinned version {version}",
  "admin.module.notify.resetAll": "Navbar + home widgets reset to defaults",
  "admin.module.notify.resetFailed": "Reset failed",
  "admin.module.notify.resetNavbar": "Navbar reset to defaults",
  "admin.module.notify.rollbackFailed": "Rollback failed",
  "admin.module.notify.saveFailed": "Save failed",
  "admin.module.notify.saved": "Saved",
  "admin.module.notify.sdkNotReady": "SDK not ready",
  "admin.module.notify.sdkNotReadyBody": "updateWorkspaceSettings unavailable.",
  "admin.module.notify.syncFailed": "Sync failed",
  "admin.module.notify.uninstallConfirm": "Uninstall module?",
  "admin.module.notify.uninstallConfirmBody": "Detaches {module} from this workspace and resets navbar, apps, and home panels to defaults.",
  "admin.module.notify.uninstallCta": "Uninstall module",
  "admin.module.notify.uninstallFailed": "Uninstall failed",
  "admin.module.notify.uninstallFailedBody": "The server rejected the request.",
  "admin.module.notify.uninstalled": "{module} uninstalled",
  "admin.module.notify.unpinned": "Unpinned (channel-tracking)",
  "admin.module.notify.unsupportedSetting": "Unsupported setting",
  "admin.module.notify.grantedCount": "+{count} granted",
  "admin.module.notify.revokedCount": "−{count} revoked",
  "admin.module.notify.approvedCount": "Access changes approved: {count}",
  "admin.module.onboard.cta": "Start — Module →",
  "admin.module.onboard.steps": "Three steps, in order: 1) Assign the module + version (its records grant is written automatically) · 2) Review the records grant · 3) Personalize the navbar, apps, panels, and skin.",
  "admin.module.onboard.title": "Set up this workspace’s module",
  "admin.module.overview.assignCta": "Assign a module →",
  "admin.module.overview.currentTitle": "Current module",
  "admin.module.overview.empty": "No module assigned. Use the Module tab to point this workspace at a published module project.",
  "admin.module.overview.quickLinks": "Quick links",
  "admin.module.page.title": "Client Module / Admin",
  "admin.module.panels.desc": "Panels new members see by default on their home dashboard — including this module’s own widgets.",
  "admin.module.panels.save": "Save panels",
  "admin.module.panels.title": "Home default panels",
  "admin.module.quick.grant": "Records grant",
  "admin.module.quick.personalize": "Personalize",
  "admin.module.quick.versions": "Versions",
  "admin.module.records.appPickerAria": "Installed app",
  "admin.module.records.desc": "The generic-record collections this module may read/write, granted automatically when it was assigned. View and revoke here — no reassign needed.",
  "admin.module.records.empty": "No records grant yet — assigning a module with declared collections (Module tab) auto-grants one.",
  "admin.module.records.levels": "Read: {read} · write: {write}",
  "admin.module.records.opAria": "Operation {op} on {collection}",
  "admin.module.records.revoke": "Revoke",
  "admin.module.records.revokeMessage": "The module loses read and write access to this collection once you save the records grant.",
  "admin.module.records.revokeTitle": "Revoke access to “{collection}”?",
  "admin.module.records.save": "Save records grant",
  "admin.module.records.saving": "Saving…",
  "admin.module.records.teamLevels": "Team {team} — read: {read} · write: {write}",
  "admin.module.records.title": "Records grant",
  "admin.module.sync.addedHeading": "Added — declared now, not yet granted",
  "admin.module.sync.apply": "Apply sync",
  "admin.module.sync.applying": "Syncing…",
  "admin.module.sync.approveAria": "Approve the access change for {collection}",
  "admin.module.sync.changedHeading": "Changed access — the app asks for a different level",
  "admin.module.sync.check": "Check for updates",
  "admin.module.sync.checking": "Checking…",
  "admin.module.sync.desc": "Reads the app's CURRENT manifest and compares it against what this workspace already granted. Nothing is written until you approve below — the app can never grant itself a collection just by publishing a new version.",
  "admin.module.sync.levelAsks": "The app asks for — read: {read} · write: {write}",
  "admin.module.sync.levelNow": "Now — read: {read} · write: {write}",
  "admin.module.sync.levelRules": "Team or field rules change too.",
  "admin.module.sync.notChecked": "Not checked yet this session.",
  "admin.module.sync.staleHeading": "Stale — granted, no longer declared",
  "admin.module.sync.title": "Grant sync",
  "admin.module.sync.upToDate": "Up to date — the granted collections match what the app currently declares.",
  "admin.module.tab.grant": "Grant",
  "admin.module.tab.module": "Module",
  "admin.module.tab.overview": "Overview",
  "admin.module.tab.personalize": "Personalize",
  "admin.module.tab.versions": "Versions",
  "admin.module.tabsAria": "Client module sections",
  "admin.module.tier.sandboxed": "Sandboxed (not executable yet — loader refuses)",
  "admin.module.tier.trusted": "Trusted (first-party, in-realm)",
  "admin.module.tierShort.sandboxed": "Sandboxed",
  "admin.module.tierShort.trusted": "Trusted",
  "admin.module.title": "Client Module",
  "admin.module.version.latest": "Latest (channel-tracked)",
  "admin.module.versions.desc": "Re-pin the workspace to any published version for an instant per-workspace rollback (no project mutation). Unpin to track the channel again.",
  "admin.module.versions.empty": "No versions loaded yet — set the module owner/key on the Module tab, then Refresh versions.",
  "admin.module.versions.lookUp": "Look up versions",
  "admin.module.versions.lookingUp": "Looking up…",
  "admin.module.versions.pin": "Pin this",
  "admin.module.versions.pinCta": "Pin",
  "admin.module.versions.pinMessage": "Everyone in this workspace runs this version of the module until you unpin it. New releases do not reach the workspace while it is pinned.",
  "admin.module.versions.pinTitle": "Pin version {version}?",
  "admin.module.versions.pinned": "Pinned",
  "admin.module.versions.pinnedHint": "Currently pinned — click to track the channel again",
  "admin.module.versions.refresh": "Refresh versions",
  "admin.module.versions.repin": "Re-pin",
  "admin.module.versions.title": "Module versions",
  "admin.module.versions.unnamed": "(unnamed)",
  "admin.module.versions.unpin": "Unpin",
  "admin.module.versions.unpinMessage": "Everyone in this workspace gets the latest version of the module’s channel again.",
  "admin.module.versions.unpinTitle": "Unpin the module version?",
  "admin.module.error.checkFailed": "Check failed.",
  "admin.module.error.dsCanvasBg": "\"canvasBg\" must be a string (a design-system color token or CSS value).",
  "admin.module.error.dsEmpty": "Design system JSON is empty.",
  "admin.module.error.dsInvalidJson": "Invalid JSON: {detail}",
  "admin.module.error.dsNotObject": "Design system must be a JSON object, e.g. { \"canvasBg\": \"…\", \"vars\": { … } }.",
  "admin.module.error.dsVarType": "\"vars.{name}\" must be a string or number.",
  "admin.module.error.dsVars": "\"vars\" must be an object of name → value pairs.",
  "admin.module.error.loadFailed": "Failed to load workspace.",
  "admin.module.error.lookupFailed": "Lookup failed.",
  "admin.module.error.noWorkspace": "No active workspace.",
  "admin.module.error.pickRef": "Pick an owner and key first.",
  "admin.module.error.projectNotFound": "Project {ref} not found.",
  "admin.nav.activityLogs": "Activity Logs",
  "admin.nav.activityScoring": "Activity Scoring",
  "admin.nav.analytics": "Analytics",
  "admin.nav.ariaLabel": "Admin navigation",
  "admin.nav.branding": "Branding",
  "admin.nav.danger": "Danger Zone",
  "admin.nav.dashboardDefaults": "Dashboard Defaults",
  "admin.nav.domains": "White-label Domains",
  "admin.nav.externalData": "External data",
  "admin.nav.flags": "Feature Flags",
  "admin.nav.groupConnections": "Connections",
  "admin.nav.groupDeveloper": "Developer tools",
  "admin.nav.groupUsage": "Usage and activity",
  "admin.nav.groupWorkspace": "Workspace",
  "admin.nav.integrations": "Integrations",
  "admin.nav.mail": "Mail",
  "admin.nav.module": "Client Module",
  "admin.nav.permissions": "Permissions Overview",
  "admin.nav.status": "Status",
  "admin.nav.systemHealth": "System Health",
  "admin.nav.teams": "Teams & Permissions",
  "admin.nav.usage": "Usage & billing",
  "admin.nav.usersRoles": "Users & Roles",
  "admin.nav.workspaceSettings": "Workspace Settings",
  "admin.npm.addScope": "+ Add scope",
  "admin.npm.back": "← Integrations",
  "admin.npm.cancel": "Cancel",
  "admin.npm.emptyHint": "Add a scope and its publish token to unlock publishing from the editor and CI.",
  "admin.npm.emptyTitle": "No npm scopes yet",
  "admin.npm.field.displayName": "Display name",
  "admin.npm.field.registry": "Registry URL",
  "admin.npm.field.scope": "Scope (@org — required)",
  "admin.npm.field.slug": "Slug",
  "admin.npm.form.title": "Add npm scope",
  "admin.npm.intro": "Store one publish token per scope. Editor CMS reads these when exporting/publishing projects; CI reads them when running `npm publish`.",
  "admin.npm.meta": "Scope: {scope} · Registry: {registry}",
  "admin.npm.page.title": "npm / Integrations",
  "admin.npm.placeholder.displayName": "Publish token",
  "admin.npm.placeholder.scope": "e.g. @acme",
  "admin.npm.placeholder.slug": "e.g. acme-prod",
  "admin.npm.registryDefault": "default",
  "admin.npm.remove": "Remove",
  "admin.npm.removeTitle": "Remove “{scope}”?",
  "admin.npm.removeMessage": "Publishing from this scope fails until you add it again.",
  "admin.npm.removeFailed": "Remove failed",
  "admin.npm.removed": "Removed",
  "admin.npm.save": "Save",
  "admin.npm.saveFailed": "Save failed",
  "admin.npm.saving": "Saving…",
  "admin.npm.scopeAdded": "Scope added",
  "admin.npm.scopeRequired": "Scope target required",
  "admin.npm.scopeRequiredBody": "Select a {scope} or switch scope to Org.",
  "admin.npm.scopeTokenRequired": "Scope and token required",
  "admin.npm.serverError": "Server error",
  "admin.npm.title": "npm registry",
  "admin.npm.token.hint": "Create with `npm token create --type=automation --cidr=0.0.0.0/0`. Scope tokens allow publishing to a specific org.",
  "admin.npm.token.label": "npm token (required — written to Vault)",
  "admin.page.activityScoring": "Activity Scoring / Admin",
  "admin.page.analytics": "Analytics / Admin",
  "admin.page.branding": "Branding / Admin",
  "admin.page.danger": "Danger Zone / Admin",
  "admin.page.dashboardDefaults": "Dashboard Defaults / Admin",
  "admin.page.domains": "White-label Domains / Admin",
  "admin.page.integrations": "Integrations / Admin",
  "admin.page.integrationsGeneric": "Integration / Admin",
  "admin.page.integrationsGithub": "GitHub / Admin",
  "admin.page.integrationsGoogle": "Google / Admin",
  "admin.page.integrationsMcp": "MCP / Admin",
  "admin.page.integrationsNpm": "npm / Admin",
  "admin.page.logs": "Logs / Admin",
  "admin.page.module": "Client Module / Admin",
  "admin.page.permissions": "Permissions / Admin",
  "admin.page.status": "Status / Admin",
  "admin.page.teams": "Teams / Admin",
  "admin.page.title": "Admin",
  "admin.page.usage": "Usage & billing / Admin",
  "admin.page.workspaceSettings": "Workspace Settings / Admin",
  "admin.perm.adminBilling.description": "Subscription tier, payment methods, plan changes",
  "admin.perm.adminBilling.label": "Manage billing",
  "admin.perm.adminCapTable.description": "View + edit cap table, grants, vesting",
  "admin.perm.adminCapTable.label": "Manage cap table",
  "admin.perm.adminCommercials.description": "Edit public-facing services, packages, pricing",
  "admin.perm.adminCommercials.label": "Manage commercials",
  "admin.perm.adminCompany.description": "Edit /company content",
  "admin.perm.adminCompany.label": "Edit company page",
  "admin.perm.adminHr.description": "Title, start date, position on other users' profiles",
  "admin.perm.adminHr.label": "Edit HR fields",
  "admin.perm.adminIntegrations.description": "Connect and configure external services",
  "admin.perm.adminIntegrations.label": "Manage integrations",
  "admin.perm.adminLogs.description": "Audit trail + security logs",
  "admin.perm.adminLogs.label": "View activity logs",
  "admin.perm.adminPagesRead.description": "Read-level access to any /admin page (blanket gate; specific write perms layered on top)",
  "admin.perm.adminPagesRead.label": "Access /admin surfaces",
  "admin.perm.adminSystem.description": "System status, danger zone, data export",
  "admin.perm.adminSystem.label": "System administration",
  "admin.perm.adminTeamPermissions.description": "Change the permission matrix on any team (separate from membership to prevent self-escalation)",
  "admin.perm.adminTeamPermissions.label": "Edit team permissions",
  "admin.perm.adminTeams.description": "Create, rename, delete teams; add/remove members",
  "admin.perm.adminTeams.label": "Manage teams",
  "admin.perm.adminUsers.description": "Invite, deactivate, reset password, view all accounts",
  "admin.perm.adminUsers.label": "Manage users",
  "admin.perm.appDescription": "{verb} access to the {app} app",
  "admin.perm.appLabel": "{app} — {verb}",
  "admin.perm.calendarCreateOrgEvents.description": "Create events visible to the whole org",
  "admin.perm.calendarCreateOrgEvents.label": "Create org events",
  "admin.perm.calendarEditOthers.description": "Modify events organized by other people",
  "admin.perm.calendarEditOthers.label": "Edit others' events",
  "admin.perm.chatArchiveChannels.description": "Archive chat channels",
  "admin.perm.chatArchiveChannels.label": "Archive channels",
  "admin.perm.chatCreateChannels.description": "Add new chat channels",
  "admin.perm.chatCreateChannels.label": "Create channels",
  "admin.perm.chatDeleteOthers.description": "Remove chat messages from other people",
  "admin.perm.chatDeleteOthers.label": "Delete others' messages",
  "admin.perm.docsDeleteOthers.description": "Remove docs authored by other people",
  "admin.perm.docsDeleteOthers.label": "Delete others' docs",
  "admin.perm.docsEditOthers.description": "Modify docs authored by other people",
  "admin.perm.docsEditOthers.label": "Edit others' docs",
  "admin.perm.docsReadPrivate.description": "View docs not explicitly shared with you",
  "admin.perm.docsReadPrivate.label": "Read private docs",
  "admin.perm.grantsViewOthers.description": "See cap-table detail for grants belonging to other people",
  "admin.perm.grantsViewOthers.label": "View others' grants",
  "admin.perm.kbDeleteOthers.description": "Remove wiki pages authored by other people",
  "admin.perm.kbDeleteOthers.label": "Delete others' KB pages",
  "admin.perm.kbEditOthers.description": "Modify wiki pages authored by other people",
  "admin.perm.kbEditOthers.label": "Edit others' KB pages",
  "admin.perm.storiesDeleteOthers.description": "Remove stories authored by other people",
  "admin.perm.storiesDeleteOthers.label": "Delete others' stories",
  "admin.perm.storiesEditOthers.description": "Modify stories authored by other people",
  "admin.perm.storiesEditOthers.label": "Edit others' stories",
  "admin.perm.storiesPin.description": "Promote stories to the top of the feed",
  "admin.perm.storiesPin.label": "Pin stories",
  "admin.perm.storiesPost.description": "Publish org-wide stories and announcements",
  "admin.perm.storiesPost.label": "Post announcements",
  "admin.perm.ticketsAssign.description": "Set assignee on tasks",
  "admin.perm.ticketsAssign.label": "Assign tasks",
  "admin.perm.ticketsCloseOthers.description": "Mark as done tasks you don't own",
  "admin.perm.ticketsCloseOthers.label": "Close others' tasks",
  "admin.perm.ticketsDeleteOthers.description": "Remove tasks you don't own",
  "admin.perm.ticketsDeleteOthers.label": "Delete others' tasks",
  "admin.perm.ticketsManageColumns.description": "Edit board columns, statuses, order",
  "admin.perm.ticketsManageColumns.label": "Manage task workflow",
  "admin.perm.verb.create": "Create",
  "admin.perm.verb.delete": "Delete",
  "admin.perm.verb.read": "Read",
  "admin.perm.verb.update": "Update",
  "admin.permGroup.admin": "Admin",
  "admin.permGroup.apps": "Apps",
  "admin.permGroup.calendar": "Calendar",
  "admin.permGroup.chat": "Chat",
  "admin.permGroup.docs": "Docs",
  "admin.permGroup.grants": "Grants",
  "admin.permGroup.kb": "KB",
  "admin.permGroup.other": "Other",
  "admin.permGroup.stories": "Stories",
  "admin.permGroup.tasks": "Tasks",
  "admin.permissions.category.active": "Active",
  "admin.permissions.category.archived": "Archived",
  "admin.permissions.category.external": "External",
  "admin.permissions.category.manager": "Manager",
  "admin.permissions.category.passive": "Passive",
  "admin.permissions.editTeams": "→ Teams",
  "admin.permissions.editTeamsTitle": "Open in Teams & Permissions editor",
  "admin.permissions.effective.colPermissions": "Permissions",
  "admin.permissions.effective.colTeam": "Team",
  "admin.permissions.effective.hint": "Every team in this organization, by category, with the permissions it has. A person can do what any of their teams can do, plus what their role allows; a passive member keeps only the passive defaults. The owner can do everything. Press “→ Teams” to change a team.",
  "admin.permissions.effective.title": "Effective permissions by team",
  "admin.permissions.elevations": "{count} permissions",
  "admin.permissions.elevationsOne": "1 permission",
  "admin.permissions.empty.active": "No active teams yet.",
  "admin.permissions.empty.external": "No external teams yet.",
  "admin.permissions.empty.manager": "No manager teams yet.",
  "admin.permissions.empty.passive": "No passive teams yet.",
  "admin.permissions.intro": "What each team can do in this organization. Each team category starts from a default set of permissions (top). Below, every team with the permissions it has now. Open a team to change them.",
  "admin.permissions.more": "+{count} more",
  "admin.permissions.moreTitle": "+{count} more permissions",
  "admin.permissions.moreTitleOne": "+1 more permission",
  "admin.permissions.noElevations": "no extra permissions",
  "admin.permissions.noPermissions": "no permissions",
  "admin.permissions.page.title": "Permissions / Admin",
  "admin.permissions.teamMetaSystem": "{category} · system",
  "admin.permissions.templates.colCategory": "Category",
  "admin.permissions.templates.colElevations": "Default permissions",
  "admin.permissions.templates.hint": "The permissions a new team gets from its category. These defaults come with the platform. In Teams & Permissions a team can then get more or fewer permissions; it shows “Customized” there when it differs from its category.",
  "admin.permissions.templates.title": "Category templates",
  "admin.permissions.title": "Permissions Overview",
  "admin.section.untitled": "Section",
  "admin.status.copied": "Copied",
  "admin.status.copyRow": "Copy {label}",
  "admin.status.count.entries": "{count} entries",
  "admin.status.count.rows": "{count} rows",
  "admin.status.disabled": "Disabled",
  "admin.status.flag.dualWriteFinancials": "mirrors grant writes to financials",
  "admin.status.flag.financialsProject": "reads grants from financials",
  "admin.status.flag.multitenant": "Phase 3 migrations + workspace RLS",
  "admin.status.flag.off": "off",
  "admin.status.flag.on": "on",
  "admin.status.flag.onboardingGate": "no-team-org users see onboarding CTA",
  "admin.status.flag.profilesOverlay": "profile writes mirror to public.profiles",
  "admin.status.hint.noOrg": "No active organization",
  "admin.status.hint.orgIntegrations": "Integration rows of the current organization",
  "admin.status.hint.orgs": "Server §A populates this",
  "admin.status.hint.profiles": "HR overlay (migration 0052)",
  "admin.status.hint.workspaceTier": "Billing display only — no access gates read this",
  "admin.status.hint.workspaces": "Drives workspace switcher",
  "admin.status.live": "Live",
  "admin.status.missingToken": "Missing token",
  "admin.status.page.title": "Status / Admin",
  "admin.status.probeError": "Probe error",
  "admin.status.probing": "Probing…",
  "admin.status.section.claims": "Session claims",
  "admin.status.section.flags": "Feature flags",
  "admin.status.section.schema": "Schema / data",
  "admin.status.title": "Status",
  "admin.teams.backToAll": "← All teams",
  "admin.teams.category.active": "Active",
  "admin.teams.category.archived": "Archived",
  "admin.teams.category.external": "External",
  "admin.teams.category.manager": "Manager",
  "admin.teams.category.passive": "Passive",
  "admin.teams.create.button": "+ Create team",
  "admin.teams.create.dialogTitle": "Create a team",
  "admin.teams.create.failed": "Could not create the team: {error}",
  "admin.teams.create.hint": "Create a new team for this org. System teams are seeded automatically.",
  "admin.teams.create.prompt": "Team name",
  "admin.teams.delete.failed": "Could not delete the team: {error}",
  "admin.teams.delete.message": "The team and its member list are deleted for good. Its members lose the permissions and access it gave them, and stay in the workspace.",
  "admin.teams.delete.messageSelf": "The team and its member list are deleted for good. You are in this team: you and its other members lose the permissions and access it gave, unless your role or another team gives them too. Everyone stays in the workspace.",
  "admin.teams.delete.title": "Delete the team “{team}”?",
  "admin.teams.detail.applyTemplate": "Apply the template",
  "admin.teams.detail.category": "Category",
  "admin.teams.detail.categoryChange": "Change category",
  "admin.teams.detail.categoryConfirmBody": "The team moves to this category. Next, you choose whether its permissions follow the category template.",
  "admin.teams.detail.categoryConfirmTitle": "Change the category to “{category}”?",
  "admin.teams.detail.categoryFailed": "Could not change the category: {error}",
  "admin.teams.detail.fallback": "Team",
  "admin.teams.detail.hintOwner": "Owners bypass all permission checks. Toggles below affect non-owner members only.",
  "admin.teams.detail.hintReadOnly": "Read-only — requires admin.team_permissions.",
  "admin.teams.detail.hintWrite": "Changes save on toggle.",
  "admin.teams.detail.keepPermissions": "Keep the permissions",
  "admin.teams.detail.loadingMembers": "Loading members",
  "admin.teams.detail.members": "Members",
  "admin.teams.detail.noMembers": "No members yet. Click + Invite to add someone.",
  "admin.teams.detail.permissions": "Permissions",
  "admin.teams.detail.resetConfirmTitle": "Reset the permissions to the “{category}” template?",
  "admin.teams.detail.resetMessage": "The template replaces this team’s current permissions.",
  "admin.teams.detail.resetToTemplate": "Reset to template",
  "admin.teams.detail.selfNote": "You are in this team: your own permissions change too.",
  "admin.teams.detail.templateMessage": "The template replaces this team’s permissions. Keep the permissions to mark the team customized.",
  "admin.teams.detail.templateTitle": "Apply the “{category}” template?",
  "admin.teams.enforce.caption": "When on, members only see and use the apps their teams grant. Owners and admins always have full access.",
  "admin.teams.enforce.label": "Enforce app access",
  "admin.teams.enforce.loading": "Loading workspace settings...",
  "admin.teams.enforce.unavailable": "Workspace settings unavailable - enforcement cannot be changed right now",
  "admin.teams.invite.copied": "Copied",
  "admin.teams.invite.copyLink": "Copy link",
  "admin.teams.invite.failed": "Invite failed: {error}",
  "admin.teams.invite.inviting": "Inviting {email}…",
  "admin.teams.invite.noEmail": "Invite created for {email} — email delivery is unavailable, share the link below.",
  "admin.teams.invite.reinviteFailed": "Reinvite failed: {error}",
  "admin.teams.invite.reinvited": "Invitation re-sent to {email}.",
  "admin.teams.invite.reinviting": "Re-inviting {email}…",
  "admin.teams.invite.send": "Send invite",
  "admin.teams.invite.sent": "Invitation sent to {email}.",
  "admin.teams.invite.sentWithTeams": "Invitation sent to {email} (teams: {teams}).",
  "admin.teams.member.reinvite": "Reinvite",
  "admin.teams.member.reinviteTitle": "Send a fresh invitation email so the user can activate / sign in",
  "admin.teams.member.removeFailed": "Could not remove {email}: {error}",
  "admin.teams.member.removeMessage": "They lose the permissions and access this team gives them, and stay in the workspace.",
  "admin.teams.member.removeSelfMessage": "You lose the permissions and access this team gives you, unless your role or another team gives them too. You stay in the workspace.",
  "admin.teams.member.removeSelfTitle": "Remove yourself from “{team}”?",
  "admin.teams.member.removeTitle": "Remove {email} from “{team}”?",
  "admin.teams.members.count": "{count} members",
  "admin.teams.members.countOne": "1 member",
  "admin.teams.members.none": "No members assigned yet",
  "admin.teams.members.unknown": "— members",
  "admin.teams.meta.customized": " • customized",
  "admin.teams.meta.perms": " • {count} perms",
  "admin.teams.meta.permsOne": " • 1 perm",
  "admin.teams.meta.slug": " • slug: {slug}",
  "admin.teams.meta.system": " • system",
  "admin.teams.meta.template": " • template",
  "admin.teams.page.title": "Teams / Admin",
  "admin.teams.perm.selfMessage": "You are in this team. Unless your role or another of your teams gives this permission, you lose it as soon as you confirm, and you may not be able to turn it back on.",
  "admin.teams.perm.selfTitle": "Turn off “{permission}” for your own team?",
  "admin.teams.perm.turnOff": "Turn off",
  "admin.teams.refreshPerms": "↻ Refresh perms",
  "admin.teams.rename.failed": "Could not rename the team: {error}",
  "admin.teams.rename.title": "Rename the team",
  "admin.teams.role.admin": "Admin",
  "admin.teams.role.editor": "Member",
  "admin.teams.role.guest": "Guest",
  "admin.teams.role.manager": "Manager",
  "admin.teams.role.member": "Member",
  "admin.teams.role.owner": "Owner",
  "admin.teams.role.superadmin": "Superadmin",
  "admin.teams.role.viewer": "Contributor",
  "admin.teams.section.active": "Active teams",
  "admin.teams.section.activeEmpty": "No active teams yet.",
  "admin.teams.section.external": "External",
  "admin.teams.section.externalEmpty": "No external teams yet.",
  "admin.teams.section.manager": "Manager teams",
  "admin.teams.section.managerEmpty": "No manager teams yet.",
  "admin.teams.section.passive": "Passive teams",
  "admin.teams.section.passiveEmpty": "No passive teams yet.",
  "admin.teams.title": "Teams & Permissions",
  "admin.teams.wsInvite.hint": "Sends a workspace invitation. Picked teams are attached on accept — they drive the member's role view.",
  "admin.teams.wsInvite.hintNamed": "Sends a workspace invitation to {workspace}. Picked teams are attached on accept — they drive the member's role view.",
  "admin.teams.wsInvite.teamsAria": "Attach teams",
  "admin.teams.wsInvite.teamsLabel": "Teams",
  "admin.teams.wsInvite.title": "Invite to this workspace",
  "admin.usage.amountOf": "{remaining} / {total} credits left",
  "admin.usage.attr.before": "Before attribution was recorded",
  "admin.usage.attr.beforeDated": "Before attribution was recorded (pre-{date})",
  "admin.usage.attr.beforeHint": "Real historical usage this workspace can no longer be tied to who or what caused it — not a member, and not zero.",
  "admin.usage.attr.eventOne": "1 event",
  "admin.usage.attr.events": "{count} events",
  "admin.usage.attr.loading": "Loading attribution…",
  "admin.usage.attr.machines": "Machines",
  "admin.usage.attr.machinesEmpty": "No machine-attributed usage in this window.",
  "admin.usage.attr.machinesSub": "API tokens, integrations, agents — a real identity that is not a person, and a configuration you can change.",
  "admin.usage.attr.members": "Members",
  "admin.usage.attr.membersEmpty": "No attributed member usage in this window.",
  "admin.usage.attr.membersSub": "A person did a thing — credits the workspace spent because they caused it, never a personal balance.",
  "admin.usage.attr.subtitle": "This month — every credit this workspace has spent, attributed to who or what caused it.",
  "admin.usage.attr.system": "System",
  "admin.usage.attr.systemEmpty": "No automatic system usage in this window.",
  "admin.usage.attr.systemSub": "Automatic — deploys, builds, scheduled jobs. No person chose this, one at a time.",
  "admin.usage.attr.title": "Where credits went",
  "admin.usage.attr.total": "Total attributed this month",
  "admin.usage.attr.unavailable": "Usage attribution isn't available for this workspace yet.",
  "admin.usage.balance.fromGrant": "Monthly credits left",
  "admin.usage.balance.fromTopups": "Top-up credits left",
  "admin.usage.balance.nextReset": "Reported reset date · {date}",
  "admin.usage.balance.poolOrgHint": "Credits shared across your organization",
  "admin.usage.balance.total": "Available credits",
  "admin.usage.burn.burned": "{credits} cr burned",
  "admin.usage.burn.none": "no burn",
  "admin.usage.burn.recent": "Recent burn",
  "admin.usage.burn.recentAvg": "Recent burn — averaging {credits} cr/day",
  "admin.usage.cause.adminAdjustment": "Admin adjustments",
  "admin.usage.cause.cdnEgress": "CDN egress",
  "admin.usage.cause.githubWorkflow": "GitHub workflow runs",
  "admin.usage.cause.other": "Other automated usage",
  "admin.usage.cause.policyEval": "Policy evaluation",
  "admin.usage.cause.retentionSweep": "Retention sweeps",
  "admin.usage.cause.scheduledReindex": "Scheduled reindex",
  "admin.usage.cause.scimSync": "SCIM sync",
  "admin.usage.cause.storageSnapshot": "Storage snapshots",
  "admin.usage.cause.templateInstall": "Template installs",
  "admin.usage.cause.webhookDelivery": "Webhook delivery",
  "admin.usage.claim.added": "100 credits added",
  "admin.usage.claim.addedBody": "Your workspace now has {count} credits.",
  "admin.usage.claim.already": "You already have credits",
  "admin.usage.claim.alreadyBody": "Your workspace has {count} credits.",
  "admin.usage.claim.available": "You have 100 free credits waiting to be claimed.",
  "admin.usage.claim.busy": "Claiming…",
  "admin.usage.claim.cta": "Claim 100 free credits",
  "admin.usage.claim.done": "✓ Your 100 free signup credits are already claimed.",
  "admin.usage.claim.failed": "Claim failed",
  "admin.usage.claim.failedBody": "Could not claim your credits.",
  "admin.usage.claim.unavailable": "Claim unavailable",
  "admin.usage.depleted.body": "This workspace has no credits left — AI calls, builds, and metered actions will fail until you top up or the monthly grant resets.",
  "admin.usage.depleted.title": "Out of credits",
  "admin.usage.error.attribution": "Attribution unavailable",
  "admin.usage.error.balance": "Balance unavailable",
  "admin.usage.error.claim": "Claim status unavailable",
  "admin.usage.error.missingRedirect": "Checkout response was missing a redirect URL.",
  "admin.usage.error.noWorkspace": "No active workspace.",
  "admin.usage.error.planUnresolved": "Couldn't resolve a plan for {tier} — refresh and try again, or talk to sales.",
  "admin.usage.error.plans": "Plans unavailable",
  "admin.usage.error.rates": "Rate card unavailable",
  "admin.usage.error.request": "request failed",
  "admin.usage.error.row": "Error",
  "admin.usage.error.sdkMissingClaim": "SDK is missing claimSignupCredits — bump @symbo.ls/sdk.",
  "admin.usage.error.sdkMissingTopup": "SDK is missing createCreditTopupCheckout — bump @symbo.ls/sdk.",
  "admin.usage.error.sdkMissingUpgrade": "SDK is missing createWorkspaceSubscriptionCheckout — bump @symbo.ls/sdk.",
  "admin.usage.error.turnStats": "Turn stats unavailable",
  "admin.usage.ledger.empty": "No activity yet",
  "admin.usage.ledgerReason.adminCredit": "Credits added by an administrator",
  "admin.usage.ledgerReason.adminDebit": "Credits removed by an administrator",
  "admin.usage.ledgerReason.aiCall": "AI request",
  "admin.usage.ledgerReason.aiSummary": "AI summary",
  "admin.usage.ledgerReason.animationExport": "Animation export",
  "admin.usage.ledgerReason.auditRetention": "Audit log retention",
  "admin.usage.ledgerReason.automationRun": "Automation run",
  "admin.usage.ledgerReason.brandbookPdf": "Brand book PDF",
  "admin.usage.ledgerReason.build": "App build",
  "admin.usage.ledgerReason.callRelay": "Call",
  "admin.usage.ledgerReason.dataTransfer": "Data transfer",
  "admin.usage.ledgerReason.deploy": "Deployment",
  "admin.usage.ledgerReason.esignature": "E-signature",
  "admin.usage.ledgerReason.failedBuildRefund": "Refund: the build did not finish",
  "admin.usage.ledgerReason.firstBuildFree": "First app build (free)",
  "admin.usage.ledgerReason.held": "Credits held for a request",
  "admin.usage.ledgerReason.heldReturned": "Held credits returned",
  "admin.usage.ledgerReason.liveCaptions": "Live call captions",
  "admin.usage.ledgerReason.mediaProcessing": "Media processing",
  "admin.usage.ledgerReason.meetingIndex": "Meeting search index",
  "admin.usage.ledgerReason.monthlyGrant": "Monthly credits",
  "admin.usage.ledgerReason.orgPool": "Organization credits",
  "admin.usage.ledgerReason.other": "Other credit activity",
  "admin.usage.ledgerReason.policyCheck": "Policy check",
  "admin.usage.ledgerReason.recordingProcessing": "Call recording processing",
  "admin.usage.ledgerReason.recordingStorage": "Call recording storage",
  "admin.usage.ledgerReason.refund": "Credits refunded",
  "admin.usage.ledgerReason.scimSync": "SCIM sync",
  "admin.usage.ledgerReason.signupClaim": "Free sign-up credits",
  "admin.usage.ledgerReason.storage": "Storage",
  "admin.usage.ledgerReason.templateInstall": "Template install",
  "admin.usage.ledgerReason.topup": "Credit top-up",
  "admin.usage.ledgerReason.transcript": "Call transcript",
  "admin.usage.ledgerReason.translation": "Translation",
  "admin.usage.ledgerReason.voiceAgent": "Voice assistant call",
  "admin.usage.ledgerReason.webhookDelivery": "Webhook delivery",
  "admin.usage.mailto.enterpriseSubject": "Enterprise plan — Symbols",
  "admin.usage.mailto.requestedTier": "Requested tier: {tier}",
  "admin.usage.mailto.unknown": "(unknown)",
  "admin.usage.mailto.upgradeSubject": "Upgrade to {tier} — Symbols",
  "admin.usage.mailto.workspace": "Workspace: {name}",
  "admin.usage.mailto.workspaceId": "Workspace ID: {id}",
  "admin.usage.noRecordedUsage": "No recorded usage.",
  "admin.usage.okOfTotal": "{ok} of {total} ({rate}%)",
  "admin.usage.page.title": "Usage & billing / Admin",
  "admin.usage.period.events": "Metered events",
  "admin.usage.period.label": "Period",
  "admin.usage.period.quantity": "Metered quantity",
  "admin.usage.period.quantityHint": "Sum across all reasons (tokens / GB / minutes / calls)",
  "admin.usage.period.thisMonth": "This month",
  "admin.usage.period.today": "Today",
  "admin.usage.perk.capabilities": "{count} platform capabilities",
  "admin.usage.perk.capabilityOne": "1 platform capability",
  "admin.usage.perk.customEnvs": "{label} · custom envs",
  "admin.usage.perk.customRateLimit": "Custom rate limit",
  "admin.usage.perk.environmentOne": "1 environment",
  "admin.usage.perk.environments": "{count} environments",
  "admin.usage.perk.projectOne": "1 project",
  "admin.usage.perk.projects": "{count} projects",
  "admin.usage.perk.rateLimit": "{count} req/min",
  "admin.usage.perk.storageIncluded": "{gb} GB storage included",
  "admin.usage.perk.support": "{name} support",
  "admin.usage.perk.unlimitedProjects": "Unlimited projects",
  "admin.usage.perk.unlimitedWorkspaces": "Unlimited workspaces",
  "admin.usage.perk.workspaceOne": "1 workspace",
  "admin.usage.perk.workspaces": "{count} workspaces",
  "admin.usage.rate.flat": "a flat rate",
  "admin.usage.rate.perCredit": "{price}/credit",
  "admin.usage.rateUnit.flat": "Flat price — credits per unit",
  "admin.usage.rateUnit.multiplier": "Relative multiplier (× base rate)",
  "admin.usage.rates.comms": "Communications",
  "admin.usage.rates.governance": "Governance & workflow",
  "admin.usage.rates.infra": "Infrastructure",
  "admin.usage.rates.modelMultipliers": "AI model multipliers (per 1K tokens)",
  "admin.usage.rates.basePrice": "Base price",
  "admin.usage.rates.basePriceHint": "AI models are priced in credits for every 1K tokens.",
  "admin.usage.rates.perThousand": "{amount} per 1K tokens",
  "admin.usage.reason.empty": "No metered events yet",
  "admin.usage.reason.emptyHint": "Credit charges appear in Recent activity.",
  "admin.usage.refresh": "Refresh",
  "admin.usage.section.byReason": "Credit use this month",
  "admin.usage.section.recent": "Recent activity (last 25)",
  "admin.usage.section.thisPeriod": "Service metering this period",
  "admin.usage.section.toolTurns": "AI tool-turn reliability",
  "admin.usage.tier.creditsFloorPerMonth": "{credits}+ credits / mo",
  "admin.usage.tier.creditsPerMonth": "{credits} credits / mo",
  "admin.usage.tier.custom": "Custom",
  "admin.usage.tier.free": "Free",
  "admin.usage.tier.priceFrom": "From {price}/mo",
  "admin.usage.tier.priceMonthly": "{price}/mo",
  "admin.usage.tiers.current": "Current plan",
  "admin.usage.tiers.note": "Review your plan in checkout before payment. For a one-time purchase, select Add credits.",
  "admin.usage.tiers.opening": "Opening Stripe…",
  "admin.usage.tiers.pooled": "Pooled across workspaces",
  "admin.usage.tiers.subtitle": "Compare monthly credits and included features. Prices are in USD.",
  "admin.usage.tiers.talkToSales": "Talk to sales →",
  "admin.usage.tiers.title": "Monthly plans",
  "admin.usage.tiers.upgrade": "Choose {plan}",
  "admin.usage.title": "Usage & billing",
  "admin.usage.topup.amount": "Amount (USD)",
  "admin.usage.topup.enterAmount": "Enter an amount.",
  "admin.usage.topup.failed": "Top-up failed.",
  "admin.usage.topup.max": "Maximum top-up is {amount}. Contact sales for larger amounts.",
  "admin.usage.topup.maximum": "Maximum",
  "admin.usage.topup.min": "Minimum top-up is {amount}.",
  "admin.usage.topup.minMax": "Minimum top-up {min}, maximum {max}.",
  "admin.usage.topup.minOnly": "Minimum top-up {min}.",
  "admin.usage.topup.minimum": "Minimum",
  "admin.usage.topup.missingUrl": "Checkout response missing url.",
  "admin.usage.topup.opening": "Opening Stripe…",
  "admin.usage.topup.quickCta": "Top up {amount}",
  "admin.usage.topup.rate": "Rate",
  "admin.usage.topup.stale": "This page is out of date — refresh to pick up the new top-up flow.",
  "admin.usage.topup.submit": "Top up",
  "admin.usage.topup.subtitle": "Buy extra credits at a flat rate. One-time payment, no subscription.",
  "admin.usage.topup.title": "Top up credits",
  "admin.usage.topup.unavailable": "Top-up unavailable",
  "admin.usage.topup.youGet": "You get",
  "admin.usage.turns.caption": "Shown to Symbols operators. The last 14 days of this workspace’s AI turns that used a tool, and how many ended with an answer — even when a tool inside the turn failed.",
  "admin.usage.turns.dedupedWrite": "{count} duplicate write prevented",
  "admin.usage.turns.dedupedWrites": "{count} duplicate writes prevented",
  "admin.usage.turns.empty": "No AI tool turns recorded in the last 14 days",
  "admin.usage.turns.label": "AI tool turns",
  "admin.usage.turns.ok": "Tool turns ok",
  "admin.usage.turns.textLeak": "{count} text leak",
  "admin.usage.turns.textLeaks": "{count} text leaks",
  "admin.usage.unit.credits": "{credits} cr",
  "admin.usage.unknownMember": "Unknown member",
  "admin.usage.unlabeledMachine": "Unlabeled machine",
  "admin.usage.upgrade.soon": "Checkout unavailable",
  "admin.usage.upgrade.soonBody": "Try again shortly, or contact sales for help.",
  "admin.usage.upgrade.unavailable": "Upgrade unavailable",
  "admin.usage.upgrade.updated": "Plan updated",
  "admin.usage.upgrade.updatedBody": "This workspace is now on {tier}.",
  "admin.users.col.name": "Name",
  "admin.users.col.role": "Role",
  "admin.users.editAria": "Edit {name}'s profile",
  "admin.users.loadingTeamAssignments": "Loading team assignments",
  "admin.workspaceSettings.nameEmpty": "Enter a name.",
  "admin.workspaceSettings.nameFailed": "The name was not saved. Try again.",
  "admin.workspaceSettings.nameHint": "Every member of this workspace sees this name.",
  "admin.workspaceSettings.nameLabel": "Workspace name",
  "admin.workspaceSettings.nameSection": "Name",
  "admin.workspaceSettings.page.title": "Workspace Settings / Admin",
  "admin.workspaceSettings.title": "Workspace Settings",
  "admin.usage.summary.loading": "Loading balance",
  "admin.usage.summary.priceUnavailable": "Price unavailable",
  "admin.usage.summary.customPrice": "Custom pricing",
  "admin.usage.summary.free": "Free plan",
  "admin.usage.summary.catalogPrice": "{price} · catalog price",
  "admin.usage.summary.noReset": "Reset date unavailable",
  "admin.usage.summary.saved": "Your saved monthly allowance still applies.",
  "admin.usage.summary.compare": "Compare plans",
  "admin.usage.nav.label": "Usage views",
  "admin.usage.nav.overview": "Overview",
  "admin.usage.nav.plans": "Plans",
  "admin.usage.nav.topup": "Add credits",
  "admin.usage.nav.activity": "Activity",
  "admin.usage.nav.rates": "Rates",
  "admin.usage.overview.unavailable": "Usage unavailable",
  "admin.usage.overview.loading": "Loading usage",
  "admin.usage.overview.unattributed": "Unattributed",
  "admin.usage.overview.share": "{percent}% of monthly use",
  "admin.usage.overview.empty": "No recorded use this month",
  "admin.usage.overview.activity": "View activity",
  "admin.usage.metered.title": "Metered services this month",
  "admin.usage.metered.units": "{credits} credits",
  "admin.usage.health.healthy": "Healthy balance",
  "admin.usage.health.low": "Top up soon",
  "admin.usage.health.critical": "Top up now",
  "admin.usage.health.empty": "Out of credits",
  "admin.usage.health.available": "Credits available",
  "admin.usage.health.short": "Not enough for your last AI request (needs {needed}, has {available})",
  "admin.usage.graph.grant": "Monthly allowance",
  "admin.usage.graph.balance": "Credit balance",
  "admin.usage.graph.allocation": "Where your credits come from",
  "admin.usage.graph.percentLeft": "{percent}% left",
  "admin.usage.graph.available": "{credits} available",
  "admin.usage.graph.left": "Available",
  "admin.usage.graph.used": "Used from allowance",
  "admin.usage.graph.spent": "Used this month",
  "admin.usage.graph.comparisonHint": "This month’s spend compared with credits available now. This is not a plan limit.",
  "admin.usage.graph.allocationHint": "Monthly credits and purchased credits make up your available balance.",
  "admin.usage.guide.cover": "Estimated time left",
  "admin.usage.guide.daily": "Credits / day · average",
  "admin.usage.guide.refillAt": "Suggested refill balance",
  "admin.usage.guide.days30": "30+ days",
  "admin.usage.guide.lessDay": "Less than 1 day",
  "admin.usage.guide.days": "~{days} days",
  "admin.usage.guide.healthy": "No top-up needed now",
  "admin.usage.guide.low": "Plan your next top-up",
  "admin.usage.guide.critical": "Add credits to keep work running",
  "admin.usage.guide.empty": "Add credits to resume work",
  "admin.usage.guide.available": "Keep a reserve for your next task",
  "admin.usage.guide.short": "Add credits to run your last AI request",
  "admin.usage.guide.shortHint": "It needs about {needed} credits and the workspace has {available}. Credits you add count toward this balance.",
  "admin.usage.guide.forecastHint": "Top up at the suggested balance to keep about 7 days in reserve. Estimates use this month’s average; new usage and resets can change them.",
  "admin.usage.guide.allowanceHint": "Consider a top-up below 30% of your monthly allowance. Purchased credits count toward your reserve.",
  "admin.usage.guide.unavailableHint": "Add credits before the balance reaches zero. More usage history is needed for a time estimate.",
  "admin.usage.summary.topupPrice": "From {price} · {credits} credits",
  "admin.usage.summary.topupNote": "One-time payment. Your plan stays the same.",
  "admin.usage.guide.resetHint": "Your monthly credits reset before the estimated balance runs out. Check again if usage rises.",
  "admin.usage.tiers.billing": "per month · USD",
  "admin.overview.members": "Members",
  "admin.overview.teams": "Teams",
  "admin.overview.activeTeams": "Active teams",
  "admin.overview.archivedTeams": "Archived teams",
  "admin.overview.activities": "Activity types",
  "admin.overview.enabled": "Enabled",
  "admin.overview.projects": "Projects",
  "admin.overview.analyticsOn": "Analytics enabled",
  "admin.overview.analyticsOff": "Analytics disabled",
  "admin.overview.connections": "Connections",
  "admin.overview.mailAccounts": "Mail accounts",
  "admin.overview.auditEntries": "Recent audit entries",
  "admin.overview.domains": "Custom domains",
  "admin.overview.widgets": "Available widgets",
  "admin.overview.visibleWidgets": "Visible by default",
  "admin.overview.checks": "Checks",
  "admin.overview.passed": "Passed",
  "admin.overview.probeErrors": "Probe errors",
  "admin.overview.templates": "Category templates",
  "admin.overview.events": "Events in view",
  "admin.overview.contributors": "Contributors",
  "admin.usage.auto.title": "Auto-top-up",
  "admin.usage.auto.description": "Keep credits available with automatic top-ups. You control the amount and monthly limit.",
  "admin.usage.auto.statusLoading": "Loading",
  "admin.usage.auto.statusUnavailable": "Unavailable",
  "admin.usage.auto.statusOff": "Off",
  "admin.usage.auto.statusActive": "Active",
  "admin.usage.auto.statusSetupRequired": "Finish card setup",
  "admin.usage.auto.statusProcessing": "Payment in progress",
  "admin.usage.auto.statusLimitReached": "Monthly limit reached",
  "admin.usage.auto.statusPaymentFailed": "Payment failed",
  "admin.usage.auto.statusAuthenticationRequired": "Card verification required",
  "admin.usage.auto.statusReconcileRequired": "Payment needs review",
  "admin.usage.auto.statusUnsupported": "Shared credit pool",
  "admin.usage.auto.noticeLoading": "Wait for your workspace settings.",
  "admin.usage.auto.noticeUnavailable": "Auto-top-up settings could not load. Owners and admins can retry.",
  "admin.usage.auto.noticeOff": "Set a balance threshold and a refill amount. Auto-top-up stays off until you complete card setup.",
  "admin.usage.auto.noticeActive": "Your saved card will pay for each top-up below the threshold. Pause at any time.",
  "admin.usage.auto.noticeSetupRequired": "Auto-top-up is off. Complete secure card setup, then refresh this status. You can also cancel or start setup again.",
  "admin.usage.auto.noticeProcessing": "A payment is in progress. Credits appear after payment succeeds. Pause stops future charges; this payment may still complete.",
  "admin.usage.auto.noticeLimitReached": "The next top-up would exceed your limit. Auto-top-up resumes next calendar month (UTC), or you can increase the limit.",
  "admin.usage.auto.noticePaymentFailed": "Auto-top-up has paused. Check your card, then complete setup again. You can also buy credits manually.",
  "admin.usage.auto.noticeAuthenticationRequired": "Auto-top-up has paused. Complete card setup again to verify your card. You can also buy credits manually.",
  "admin.usage.auto.noticeReconcileRequired": "A payment result is unknown. Auto-top-up has paused to prevent a duplicate charge. Contact support before you retry.",
  "admin.usage.auto.noticeUnsupported": "This workspace uses an organization credit pool. Manage its balance through organization billing.",
  "admin.usage.auto.metricThreshold": "When balance is below",
  "admin.usage.auto.metricRefill": "Add credits for",
  "admin.usage.auto.metricCap": "Stop at",
  "admin.usage.auto.below": "credits remaining",
  "admin.usage.auto.credits": "{credits} credits per top-up",
  "admin.usage.auto.perMonth": "per calendar month (UTC)",
  "admin.usage.auto.spent": "{spent} of {limit} used this month",
  "admin.usage.auto.budget": "Monthly auto-top-up budget in USD",
  "admin.usage.auto.card": "{brand} ending in {last4}",
  "admin.usage.auto.triggerLabel": "Balance threshold (credits)",
  "admin.usage.auto.amountLabel": "Each top-up (USD)",
  "admin.usage.auto.limitLabel": "Monthly limit (USD)",
  "admin.usage.auto.rateHint": "{rate} per credit. Each top-up: {min} to {max}. The monthly limit excludes manual top-ups and subscriptions.",
  "admin.usage.auto.validationRates": "Prices are unavailable. Refresh usage before you continue.",
  "admin.usage.auto.validationAmount": "Enter an amount within the stated limits, with at most two decimal places.",
  "admin.usage.auto.validationThreshold": "Enter a whole credit threshold above zero and below the credits in one top-up.",
  "admin.usage.auto.validationLimit": "Set a monthly limit at least equal to one top-up, within the stated maximum.",
  "admin.usage.auto.review": "Review rule",
  "admin.usage.auto.cancel": "Cancel",
  "admin.usage.auto.reviewTitle": "Review automatic payments",
  "admin.usage.auto.reviewDescription": "Stripe will save your card. A top-up can charge immediately after setup if your balance is already below the threshold.",
  "admin.usage.auto.consent": "I authorize recurring card charges under this rule, up to the monthly limit. I can pause auto-top-up in Usage at any time.",
  "admin.usage.auto.wait": "Please wait…",
  "admin.usage.auto.prepare": "Set up payment",
  "admin.usage.auto.back": "Edit rule",
  "admin.usage.auto.secureHint": "Your rule is ready. Complete card setup in Stripe to activate it. Symbols does not store your card number.",
  "admin.usage.auto.continue": "Continue to Stripe",
  "admin.usage.auto.edit": "Edit auto-top-up",
  "admin.usage.auto.setup": "Set up auto-top-up",
  "admin.usage.auto.pause": "Pause auto-top-up",
  "admin.usage.auto.refresh": "Refresh status",
  "admin.usage.auto.errorUnavailable": "Auto-top-up is unavailable in this version. Refresh the app and try again.",
  "admin.usage.auto.errorForbidden": "Only workspace owners and admins can manage auto-top-up.",
  "admin.usage.auto.errorInProgress": "A payment is still in progress. Refresh its status before you change the rule.",
  "admin.usage.auto.errorFailed": "The request failed. Check the status, then try again. Auto-top-up activates only after successful card setup.",
  "admin.usage.topup.returnCancelled": "No payment was made.",
  "admin.usage.topup.returnConfirming": "Confirming your payment…",
  "admin.usage.topup.returnFailed": "We could not confirm the payment yet.",
  "admin.usage.topup.returnPaid": "Payment received. {credits} credits added.",
  "admin.usage.topup.returnPaidNoCount": "Payment received. Credits added.",
  "admin.usage.topup.returnRetry": "Try again"
}
